import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import IntegrationsListItem from './ListItem';

const IntegrationsList = ({
  integrations,
  ...props
}) => {
  const intl = useIntl();

  return (
    <>
      {integrations.length > 0 ? (
        <div className="integrations-list">
          {integrations.map(integration => (
            <IntegrationsListItem
              key={integration.id}
              integration={integration}
              {...props}
            />
          ))}
        </div>
      ) : (
        <div className="nothing-found-wrapper bottom">
          <h3>
            {intl.formatMessage({ defaultMessage: 'No integrations found' })}
          </h3>
        </div>
      )}
    </>
  );
};

IntegrationsList.propTypes = {
  integrations: PropTypes.array.isRequired,
  disconnectingServiceId: PropTypes.string,
  handleDisconnect: PropTypes.func.isRequired,
};

IntegrationsList.defaultProps = {
  disconnectingServiceId: null,
};

export default IntegrationsList;
